import React, { useEffect, useState, useCallback } from "react";
import { db } from "../firebase-config";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { Link } from "react-router-dom";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

import Hero from "../Components/Hero.jsx";
import SmallContact from "../Components/Contact_home.jsx";
import PageTransition from "../Components/PageTransition";
import HomeTestimonial from "../Components/HomeTestimonials.jsx";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./CSS/Home.css";

function Home() {
  const [galleryItems, setGalleryItems] = useState([]);
  const [services, setServices] = useState([]);
  const [latestNews, setLatestNews] = useState([]);
  const storage = getStorage();


  const fetchData = useCallback(async (colName, orderField, limitCount = 6) => {
    try {
      const refCol = collection(db, colName);
      const q = query(refCol, orderBy(orderField, "desc"), limit(limitCount));
      const snap = await getDocs(q);

      return Promise.all(
        snap.docs.map(async (doc) => {
          const data = doc.data();
          let imageUrl = data.imageUrl || "";
          
          // Handle Cloudinary URLs and Firebase Storage URLs
          if (imageUrl && !imageUrl.startsWith("http")) {
            try {
              imageUrl = await getDownloadURL(ref(storage, imageUrl));
            } catch (error) {
              console.error("Error getting download URL:", error);
              imageUrl = "";
            }
          }
          
          return { id: doc.id, ...data, imageUrl };
        })
      );
    } catch (err) {
      console.error(`Error fetching ${colName}:`, err);
      return [];
    }
  }, [storage]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [galleryData, servicesData, newsData] = await Promise.all([
          fetchData("gallery", "uploadedAt", 6),
          fetchData("services","createdAt",6),
          fetchData("news", "updatedAt", 3) 
        ]);
        
        setGalleryItems(galleryData);
        setServices(servicesData);
        setLatestNews(newsData);
        
        // Debug logging
        console.log("Gallery data:", galleryData);
        console.log("Services data:", servicesData);
        console.log("News data:", newsData);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    loadData();
  }, [fetchData]);

  return (
    <PageTransition>
      <div className="home-page bg-background">
        {/* Hero Section */}
        <Hero />

        {/* Gallery Section */}
        <section className="gallery-grid-section py-5">
          <div className="container">
            <h2 className="section-title">Latest Gallery</h2>
            <div className="row g-4">
              {galleryItems.length > 0 ? (
                galleryItems.map((item, i) => (
                  <div key={item.id} className="col-lg-6 col-md-6 col-12">
                    <div
                      className="gallery-card animate-fade-slide"
                      style={{ animationDelay: `${i * 0.12}s` }}
                    >
                      <img
                        src={item.imageUrl || '/default-image.jpg'}
                        alt={item.title || "Gallery"}
                        className="gallery-card-img"
                        onError={(e) => {
                          e.target.src = '/default-image.jpg';
                        }}
                      />
                      <div className="gallery-card-overlay">
                        <h4 className="gallery-card-title text-muted">
                          {item.title || "Untitled"}
                        </h4>
                        <p className="gallery-card-desc">
                          {item.description || "No description."}
                        </p>
                        <Link to="/gallery" className="btn-accent">
                          View More
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center">
                  <p>No gallery items found.</p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Services Section */}
<section id="services-section" className="home-section services-section">
  <div className="container">
    <div className="d-flex justify-content-between align-items-center mb-3">
  <h2 className="section-title mb-0">Milestones of Compassion</h2>
  <Link to="/services" className="btn btn-outline btn-sm ms-auto">
    See All
  </Link>
</div>

    <div className="row ">
      {services.length > 0 ? (
        services.map((item, i) => (
          <div className="col-md-4 mb-4 " key={item.id}>
            <Link to={`/services/${item.id}`} className="text-decoration-none">
              <div
                className="card home-card h-100 text-center bg-light animate-fade-slide"
                style={{ animationDelay: `${i * 0.12}s` }}
              >
                {item.imageUrl && (
                  <img
                    src={item.imageUrl}
                    className="card-img-top"
                    alt={item.title}
                    style={{ objectFit: "cover", height: "140px" }}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title mb-0">{item.title}</h5>
                </div>
              </div>
            </Link>
          </div>
        ))
      ) : (
        <div className="col-12 text-center">
          <p>No services found.</p>
        </div>
      )}
    </div>
  </div>
</section>


        {/* Latest News Section */}
{/* Latest News Section */}
<section className="home-section py-5">
  <div className="container ">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="section-title mb-0">Latest News</h2>
      <Link to="/news" className=" btn-outline  btn-sm">
        See All
      </Link>
    </div>
    <div className="row">
      {latestNews.length > 0 ? (
        latestNews.map((news) => (
          <div className="col-md-12 mb-3" key={news.id}>
            <Link
              to={`/news/${news.id}`}
              className="text-decoration-none text-dark"
            >
              <div className="card flex-row shadow-sm h-100 latest-news-card bg-light">
                <img
                  src={news.imageUrl || '/default-news-image.jpg'}
                  alt={news.title}
                  style={{
                    width: "160px",
                    height: "100%",
                    objectFit: "cover",
                    borderTopLeftRadius: "0.375rem",
                    borderBottomLeftRadius: "0.375rem",
                  }}
                  onError={(e) => {
                    e.target.src = '/default-news-image.jpg';
                  }}
                />
                <div className="card-body">
                  <h5 className="card-title mb-1">{news.title}</h5>
                  <small className="text-dark">
                    {news.author && `By ${news.author}`}
                  </small>
                </div>
              </div>
            </Link>
          </div>
        ))
      ) : (
        <div className="col-12 text-center">
          <p>No news articles found.</p>
        </div>
      )}
    </div>
  </div>
</section>

        {/* Testimonials */}
        <HomeTestimonial />

        {/* Contact Section */}
        <SmallContact />
      </div>
    </PageTransition>
  );
}

export default Home;
